import styles from "./index.module.less";
import { Iconsvg } from "@wk/components-react16";
import { useUser } from "@/utils/UserContext";
import { AvatarUserPlaceholder } from "@wk/components-react16";
import { useNavigate, useLocation } from "react-router-dom";
const pathList = [
  "/player",
  "/player/detail",
  "/player/personalCases",
  "/player/personalCases/add",
  "/player/personalCases/edit",
];

const Header = () => {
  const { user, set, judge, setJudgeInfo } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  const exit = () => {
    set({});
    setJudgeInfo({});
    if (pathList.includes(location.pathname)) {
      navigate("/");
    }
  };

  return (
    <div className={styles["header-view"]}>
      <div className="left">
        <div className="text">关于Wolters Kluwer</div>
        <Iconsvg name="chevron-down" size={14}></Iconsvg>
      </div>
      <div className="right">
        {!(user && user?.status === "1") && !(judge && judge?.id) && (
          <div className="text login" onClick={() => navigate("/login")}>
            登录/注册
          </div>
        )}

        {user && user?.status === "1" && (
          <div
            className="text add"
            onClick={() => navigate("/player/personalCases/add")}
          >
            投稿案例
          </div>
        )}

        <div
          className={
            (user && user?.status === "1") || (judge && judge?.id)
              ? "user-info"
              : "no-login"
          }
        >
          <AvatarUserPlaceholder size="extra-small"></AvatarUserPlaceholder>
          <div className="card">
            <div
              onClick={() => {
                if (user && user?.status === "1") {
                  navigate("/player");
                } else if (judge && judge?.id) {
                  navigate("/judgesHomepage");
                }
              }}
            >
              <Iconsvg name="user" size={24}></Iconsvg>
              <div className="title">个人主页</div>
            </div>

            <div
              onClick={() => {
                if (user && user?.status === "1") {
                  navigate("/player/detail");
                } else if (judge && judge?.id) {
                  navigate("/judgesHomepage/detail");
                }
              }}
            >
              <Iconsvg name="mail-address" size={24}></Iconsvg>
              <div className="title">资料信息</div>
            </div>

            <div onClick={exit}>
              <Iconsvg name="logout" size={24}></Iconsvg>
              <div className="title">退出系统</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Header;
